import { combineStrings } from 'assets/utils/data/String';
import ContractRefundPayee from 'models/sales/contractRefundPayee/Model.ContractRefundPayee';
import VertaforeClient from 'models/integration/vertafore/Model.VertaforeClient';
import Model from 'models/Model';
import clientListApi from './list/Api.Client.List';
import clientSyncWithVertaforeApi from './syncWithVertafore/Api.Client.SyncWithVertafore';

export default class Client
  extends Model<Model.IClient>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClient>
{
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;

  streetAddress: string;
  postalCode: string;
  muncipality: string;
  provinceCode: string;
  countryCode: string;
  city: string;

  taxExempt: boolean;

  primaryLangugaeIsoCode?: string;
  bandNumber?: string;
  taxExemptionBand?: string;
  isLegacy?: boolean;

  //#region Vertafore
  vertaforeCustomerNumber?: string;
  vertaforeClientId?: number;
  vertaforeClient?: VertaforeClient;
  //#endregion

  readonly name?: string;
  readonly phoneNumber?: string;
  readonly address?: string;

  constructor(data: Partial<Model.IClient> | Utils.FormData<Model.IClient>, language?: Locale.Languages) {
    super(
      {
        vertaforeClient: VertaforeClient,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: combineStrings(' ', this.firstName, this.lastName) || '',
      subtitle: this.fullAddress,
    };
  }

  get fullAddress() {
    return combineStrings(', ', this.streetAddress, combineStrings(' ', this.postalCode, this.provinceCode));
  }
  toContractRefundPayee(): ContractRefundPayee {
    return new ContractRefundPayee({
      clientId: this.id,
      client: this,
      isPrimary: true,
      paymentMethodCode: undefined,
    });
  }

  static async list(body?: Api.Core.Client.List.IRequest) {
    const { payload, ...rest } = await clientListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new Client(it)),
        count: payload.count,
      },
    };
  }
  static async syncWithVertafore(params: Api.Core.Client.SyncWithVertafore.IParams) {
    return await clientSyncWithVertaforeApi(params);
  }
}
